import { Line } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";

const BarChartComponent = (props) => {
  Chart.register(CategoryScale);

  const { list, type } = props;

  let countData = [];
  let nameLabels = [];
  countData = list.map((item) => {
    return item.count;
  });

  let MaxValue = Math.max(...countData);

  let AvgOfMax = MaxValue / 10;
  MaxValue = MaxValue + AvgOfMax;

  AvgOfMax = Math.round(AvgOfMax);

  nameLabels = list.map((item) => {
    return item.name;
  });

  const state = {
    labels: nameLabels,
    datasets: [
      {
        type: "bar",
        labels: "Bar Chart",
        borderColor: [
          "#25287a",
          "#ed4613",
          "#63ddeb",
          "#e9abff",
          "#f7e672",
          "#3d9470",
          "#d43b48",
        ],
        backgroundColor: [
          "#25287a",
          "#ed4613",
          "#63ddeb",
          "#e9abff",
          "#f7e672",
          "#3d9470",
          "#d43b48",
        ],

        data: countData,
        borderWidth: 2,
        borderRadius: 5,
      },
    ],
  };

  return (
    <div style={{ width: "100%", padding: "50px" }}>
      <Line
        datasetIdKey="id"
        data={state}
        options={{
          animation: false,
          indexAxis: "y",
          responsive: true,
          plugins: {
            tooltip: {
              usePointStyle: true,
            },
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                padding: 20,
              },
            },
            datalabels: {
              callback: (value) => value, // Add the percentage after the value
              align: "end",
              anchor: "end",
              color: "black",
              clip: true,
              formatter: (value) => {
                return value;
              },
            },
          },

          scales: {
            x: {
              max: MaxValue,
              min: 0,
              grid: {
                display: false,
              },
              ticks: {
                stepSize: AvgOfMax,
                color: "black",
                font: {
                  size: 13,
                },
              },
            },
            y: {
              ticks: {
                color: "black",
                font: {
                  size: 13,
                },
                // callback: function (value, index, values) {
                //   return value;
                // },
              },

              grid: {
                display: false,
              },
            },
          },
        }}
      />
    </div>
  );
};

export default BarChartComponent;
